import { Sprite } from '@ktag/styleguide/dist/react';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import formatDate from 'utils/formatDate';

interface Props {
  noSeats: boolean;
  nextElectionDate: string;
  round: number;
}

const ElectionTeaserInfo = ({ noSeats, nextElectionDate, round }: Props) => {
  const { t } = useTranslation('wap');

  const translationString = noSeats ? 'info_no_seats' : 'info_not_all_seats';

  return (
    <div className="electionteaser__info">
      <Sprite id="i-circle" />
      <div>
        <Trans
          t={t}
          i18nKey={translationString}
          values={{
            date: formatDate(nextElectionDate, {
              month: 'long',
              year: 'numeric',
              day: 'numeric',
            }),
            round: round + 1,
          }}
        >
          <span>
            Es konnten nicht alle Sitze vergeben werden. Der X. Wahlgang findet am
          </span>
          <span className="electionteaser__info-date">Datum</span>
          <span>statt</span>
        </Trans>
      </div>
    </div>
  );
};

export default ElectionTeaserInfo;
